import { fetchRequestPrev } from "@providers/conect_prev";

const verDispApi = async ( data ) => {

  try {
    const url = `integrations/previplan/consultar-fechas-disponibles`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verDispApi };
